import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, Space } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import {
  isAdminRoleSelector,
  isStaffRoleSelector,
  bleEnabledSelector,
} from '@store/common/selectors';
import { METRIC_TO_ALERT_METRIC_MAPPING } from '@utils/aiAlerts/alertMetrics';
import ManualAlertContext, { IAction } from '../context';
import { FormActionContext } from '../form/context';
interface IProps {
  alert: ManualAlert;
}

const Actions = ({ alert }: IProps) => {
  const { actions } = useContext(ManualAlertContext);
  const { actions: formActions } = useContext(FormActionContext);
  const isAdmin = useSelector(isAdminRoleSelector);
  const isStaff = useSelector(isStaffRoleSelector);

  // to make sure users dont click on old metric alert actions
  const { metric } = alert;
  const isBusinessMetricsEnabled = useSelector(bleEnabledSelector);
  const allowedAlertMetric = Object.values(
    METRIC_TO_ALERT_METRIC_MAPPING(isBusinessMetricsEnabled),
  );

  const isValidAlertMetric = allowedAlertMetric.includes(metric);

  if (!isAdmin && !isStaff) {
    return null;
  }

  const onApply = ({ key }) => {
    const { toggleAlerts } = actions as IAction;
    switch (key) {
      case 'enable': {
        toggleAlerts({
          variables: { alertIds: [alert.id], state: true },
        });
        break;
      }
      case 'disable': {
        toggleAlerts({
          variables: { alertIds: [alert.id], state: false },
        });
        break;
      }
      case 'delete': {
        const { onDelete } = formActions;
        onDelete(alert);
        break;
      }
      case 'edit': {
        const { onEdit } = formActions;
        onEdit(alert);
        break;
      }
      case 'clone': {
        const { onEdit } = formActions;
        onEdit({ ...alert, id: null } as any as ManualAlert);
        break;
      }
    }
  };

  const items = [
    { key: 'edit', label: 'Edit' },
    { key: 'clone', label: 'Clone' },
    { key: 'delete', label: 'Delete' },
  ];

  if (alert.state) {
    items.push({
      key: 'disable',
      label: 'Disable',
    });
  } else {
    items.push({
      key: 'enable',
      label: 'Enable',
    });
  }

  if (isValidAlertMetric) {
    return (
      <Dropdown menu={{ items, onClick: onApply }} trigger={['click']}>
        <Space>
          <MoreOutlined />
        </Space>
      </Dropdown>
    );
  }
  return null;
};

export default Actions;
